/**
 * Records a page-view event on every route change. Renders nothing; mounts
 * inside the Router so it can read the current location. Authenticated-only
 * (the events client no-ops without a token).
 */
import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import { recordPageView } from "../api/events"

function UsageTracker(): null {
  const location = useLocation()
  useEffect(() => {
    recordPageView(location.pathname)
  }, [location.pathname])
  return null
}

export default UsageTracker
